function escaped(text, index) {
  let slashes = 0;
  while (index > 0 && text[--index] === '\\') slashes++;
  return slashes % 2 === 1;
}

// Keep code atomic. Display formulae can contain Markdown-looking symbols,
// matrix row breaks, or citations; none of those should be parsed as prose.
export function splitDisplayMath(text) {
  const output = []; let start = 0, i = 0;
  const pushText = end => { if (end > start) output.push({ type: 'text', text: text.slice(start, end) }); };
  while (i < text.length) {
    if (i === 0 || text[i - 1] === '\n') {
      const fence = text.slice(i).match(/^[ \t]{0,3}(`{3,}|~{3,})[^\n]*\n/);
      if (fence) {
        const close = new RegExp('^[ \\t]{0,3}' + fence[1][0] + '{' + fence[1].length + ',}[ \\t]*\\r?(?:\\n|$)', 'gm');
        close.lastIndex = i + fence[0].length;
        i = close.exec(text) ? close.lastIndex : text.length;
        continue;
      }
    }
    if (text.startsWith('https://', i) || text.startsWith('http://', i)) {
      const end = text.slice(i).search(/[\s<>)]/);
      i = end < 0 ? text.length : i + end;
      continue;
    }
    if (text[i] === '`' && !escaped(text, i)) {
      const run = text.slice(i).match(/^`+/)[0];
      const end = text.indexOf(run, i + run.length);
      i = end < 0 ? text.length : end + run.length;
      continue;
    }
    let open = '', close = '', keepEnvironment = false;
    if (!escaped(text, i)) {
      if (text.startsWith('$$', i)) { open = '$$'; close = '$$'; }
      else if (text.startsWith('\\[', i)) { open = '\\['; close = '\\]'; }
      else if (text.startsWith('\\begin{', i)) {
        const environment = text.slice(i).match(/^\\begin\{(equation\*?|align\*?|gather\*?)\}/);
        if (environment) { open = environment[0]; close = '\\end{' + environment[1] + '}'; keepEnvironment = true; }
      }
    }
    if (!open) { i++; continue; }
    let end = text.indexOf(close, i + open.length);
    while (end >= 0 && escaped(text, end)) end = text.indexOf(close, end + close.length);
    pushText(i);
    if (end < 0) {
      output.push({ type: 'pending', text: text.slice(i) });
      start = text.length; break;
    }
    output.push({ type: 'math', text: keepEnvironment ? text.slice(i, end + close.length) : text.slice(i + open.length, end), raw: text.slice(i, end + close.length) });
    i = end + close.length; start = i;
  }
  pushText(text.length);
  return output;
}

export { escaped as mathIsEscaped };
